const STORAGE_KEY = 'cmmi_custom_view_tour_seen'

export function useCustomViewTour() {
  const hasSeen = (): boolean => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
      return false
    }
  }

  const markSeen = (): void => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true')
    } catch {
      // localStorage unavailable — silently ignore
    }
  }

  const resetTour = (): void => {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      // localStorage unavailable — silently ignore
    }
  }

  return { hasSeen, markSeen, resetTour }
}
